import {PERMISSION} from '@generated-backend-types';
import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRouteSnapshot} from '@angular/router';
import {UserSessionService} from '../services/user-session-service/user-session.service';

@Injectable({providedIn: 'root'})
export class CanActivateGuard {
  private readonly userSessionService = inject(UserSessionService);
  private readonly toastr = inject(ToastrService);
  private readonly translateService = inject(TranslateService);


  public canActivate(route: ActivatedRouteSnapshot) {

    const allPermissionsNeeded: PERMISSION[] | undefined = route.data['allPermissionsNeeded'];
    const anyPermissionNeeded: PERMISSION[] | undefined = route.data['anyPermissionNeeded'];
    const showToastIfNeededPermissionsMissing: boolean | undefined = route.data['showToastIfNeededPermissionsMissing'] ?? true;

    let can = this.userSessionService.hasAllPermission(allPermissionsNeeded ?? [])
    if (!can && showToastIfNeededPermissionsMissing) {
      this.toastr.warning(this.translateService.instant('shared.permissions.missing_permission', {missingPermissions: allPermissionsNeeded}));
    }

    if (can && anyPermissionNeeded && anyPermissionNeeded.length > 0) {
      can = this.userSessionService.hasAnyPermission(anyPermissionNeeded)
    }
    return can
  }
}
